import getToggle from './modules/toggle';
import getModal from './modules/modal';

'use strict';

getToggle();
getModal();
